import {Component, effect, inject} from '@angular/core';
import {INITIAL_STATE_TOKEN} from 'frontier/nucleus';
import {SharedGridOptions, TableControlComponent, TableControlModule, ToolbarStore} from 'frontier/browserkit';
import {GridOptions} from 'ag-grid-community';
import AppControlGuids from '../../../../../api/ControlGuids';

@Component({
  selector: 'app-tariff-keys',
  templateUrl: '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
  providers: [{provide: INITIAL_STATE_TOKEN, useValue: {filter: null}}],
})
export class TariffKeysComponent extends TableControlComponent {
  private toolbarStore: ToolbarStore = inject(ToolbarStore);
  override GUID: string = AppControlGuids.TTaxKeyView;
  override tableName: string = 'Steuerschlüssel';
  override gridOptions: GridOptions = {
    ...SharedGridOptions,
    rowSelection: 'multiple',
  };

  constructor() {
    super();
    effect(() => {
      const toolbarFilterDto = this.toolbarStore.toolbarFilterDto();
      if (toolbarFilterDto) {
        this.patchFilter({
          ...toolbarFilterDto,
        });
      }
    }, {allowSignalWrites: true});
  }
}
